import { render, staticRenderFns } from "./VotingResult.vue?vue&type=template&id=1d18460e&scoped=true"
import script from "./VotingResult.vue?vue&type=script&lang=js"
export * from "./VotingResult.vue?vue&type=script&lang=js"
import style0 from "./VotingResult.vue?vue&type=style&index=0&id=1d18460e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d18460e",
  null
  
)

export default component.exports